import { useCallback, useMemo } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJSDTeamByIdURL } from '../../common/utils.tsx';

export type Team = {
	id: string;
	platformTeamId: string;
};

export type Response = {
	data?: Team;
	loading: boolean;
	error?: Error;
	fetchTeamInfo: Function;
};

const useGetTeamById = (): Response => {
	const request = useCallback(
		(ogTeamId: string) => performGetRequest(getJSDTeamByIdURL(ogTeamId)),
		[],
	);
	const { loading, error, data, fetch } = useService<Team, string>(request, { loading: false });
	const memoisedData = useMemo(() => data, [data]);
	return { loading, error, data: memoisedData, fetchTeamInfo: fetch };
};
export default useGetTeamById;
